module.exports = __webpack_public_path__ + "img/application_icon_password_active.1644a509.png";